module.exports = __webpack_public_path__ + "static/P2-f866aff675590d10b90a173b9c4c358f.webp";